// extracted by mini-css-extract-plugin
export default {"icon":"CSVDownload_icon__cW9HL","disabled":"CSVDownload_disabled__FYDhl"};